<template>
    <div>
    <b-form>
        <!-- <fr-social-buttons v-if="!isSocialReg" :signin="false"></fr-social-buttons> -->
            <div class="ssrv-header-0">

                <div class="ssrv-sub-hdr-1">

                    <div class="ssrv-hdr-1">
                    </div>
                    <h2>
                        {{ $t('pages.orgadmin.promoteheader') }}
                    </h2>
                </div>
            </div>
            <div class="ssrv-top-0">
                <div class="ssrv-0">
                    <div class="ssrv-0">
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="userName" class="safeLabel">{{$t('pages.app.orgadminworkflow.basicuseremail')}}</label>
                                <b-form-input id="userName" v-model="saveDetails.userName" class="ssrv-form-control" v-on:blur="offFocus('userName')" :placeholder="[[ $t('pages.app.orgadminworkflow.basicuseremail') ]]"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="showErrorField()" style="font-color:red;color:red">{{ validProperties.userName }}</div>
                        </div>
                        <div class="ssrv-0">
                            <div class="ssrv-1">
                                <label for="desc" class="safeLabel">{{$t('pages.app.orgadminworkflow.reasonforpromotion')}}</label>
                                <b-form-input id="desc" v-model="saveDetails.description" v-on:blur="offFocus('description')" class="ssrv-form-control" :placeholder="[[ $t('pages.app.orgadminworkflow.reasonforpromotion') ]]"></b-form-input>
                            </div>
                            <div class="ssrv-50" v-if="showErrorField()" style="font-color:red;color:red">{{ validProperties.description }}</div>
                        </div>
                        <div class="ssrv-0">
                            <div style="float: left; padding-left: 20px">
                                <div><input type="checkbox" id="checkbox-1" v-model="removeAdmin" name="removeAdminPrivs" value="true" unchecked-value="false"></div>
                            </div>
                            <div style="float: left; width: 80%">
                                <div><label for="checkbox-1">{{$t('pages.app.orgadminworkflow.removeadminpriv')}}</label></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ssrv-space"></div>
            </div>
            <br>
            <div class="ssrv-0">
                <div class="ssrv-3">
                    <!-- <b-button @click="save" :block="true" size="lg" variant="primary" active-class="ssrv-form-button" class="ssrv-form-button" :disabled="!certificationPassed"> -->
                    <b-button @click="save" :block="true" size="lg" variant="primary" active-class="ssrv-form-button" class="ssrv-form-button">
                        {{$t("common.form.submit")}}
                    </b-button>
                </div>
                <div class="ssrv-3">
                    <div class="ssrv-50" style="font-color:red;color:red">{{this.processTask}}</div>
                </div>
            </div>
            <!-- modal to show a user successfully sent their account creation request -->
            <b-modal id="successModal"
                     ref="successModal"
                     :title="this.$t('pages.orgadmin.submitTitle')">

                <div>
                    {{ this.popupState }}
                </div>

                <div slot="modal-footer" class="w-100">
                    <div class="float-right">
                        <b-btn type="button" @click="successRequest">{{$t('common.form.confirm')}}</b-btn>
                    </div>
                </div>
            </b-modal>
        </b-form>

    </div>
</template>

<script>
import _ from 'lodash';

/**
 * @description Selfservice stage for generating user details and displaying social buttons available. Works the same alone and in allinone
 *
 **/
export default {
    name: 'User-Details',
    components: {

    },
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        selfServiceDetails: { required: true },
        inline: {
            required: false,
            default: false
        }
    },
    data () {
        var data = {
            userDetails: {
                userName: '',
                description: ''
            },
            saveDetails: {
                userName: '',
                description: ''
            },
            removeAdmin: false,
            userPreferences: {},
            isSocialReg: _.get(this.selfServiceDetails, 'tag') !== 'initial',
            validProperties: {
                userName: '',
                description: ''
            },
            id: this.$route.params.resourceId,
            user: this.$root.userStore.state,
            processTask: '',
            orgAdminMatch: false,
            defName: 'BasicUserPromotionRequest3',
            popupState: this.$t('pages.orgadmin.submit')
        };

        // if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationProperties) {
        //     data.userDetails = this.selfServiceDetails.requirements.registrationProperties.properties;
        //
        //     if (_.has(this.selfServiceDetails, 'requirements.properties.user.default') &&
        //             !_.isUndefined(this.selfServiceDetails, 'requirements.properties.user.default')) {
        //         _.each(this.selfServiceDetails.requirements.properties.user.default, (value, key) => {
        //             data.userDetails[key].socialValue = value;
        //         });
        //     }
        //
        //     _.each(this.selfServiceDetails.requirements.registrationProperties.required, (prop) => {
        //         data.userDetails[prop].required = true;
        //     });
        //
        //     _.each(this.selfServiceDetails.requirements.registrationProperties.properties, (value, key) => {
        //         data.saveDetails[key] = '';
        //     });
        // }

        // if (this.selfServiceDetails.requirements && this.selfServiceDetails.requirements.registrationPreferences) {
        //     data.saveDetails.preferences = {};
        //     data.userPreferences = this.selfServiceDetails.requirements.registrationPreferences;
        //
        //     _.each(data.userPreferences, (value, key) => {
        //         data.saveDetails.preferences[key] = false;
        //     });
        // }

        // data.saveDetails.password = '';

        return data;
    },
    // computed: {
    //
    // },
    methods: {
        getData () {
            let details = _.clone(this.saveDetails);

            return {
                user: details
            };
        },

        // Add additional frontend checks for field validation here
        calculateValidation (property) {
            let validators = [];

            if (property.required) {
                validators.push('required');
            }

            if (property.policies) {
                // Add policy vee validators correlations here
                _.each(property.policies, (policy) => {
                    if (policy.policyId === 'valid-email-address-format') {
                        validators.push('email');
                    }
                });
            }

            return validators.join('|');
        },

        showErrorField () {
            if (this.companyExists === false) {
                if (this.companyIdType === 'RR' || this.companyIdType === 'CL') {
                    return false;
                }
            }
            return true;
        },

        offFocus (property) {
            // var obj = {},
            //     axios = require('axios'),
            //     wfdata = '',
            //     config = {};
            // obj[property] = this.saveDetails[property];
            // wfdata = JSON.stringify(obj);
            // config = {
            //     method: 'post',
            //     'url': 'https://stage.myaccess.texas.gov/rrc/openidm/policy/managed/user/test?_action=validateProperty',
            //     'headers': {
            //         'X-OpenIDM-Username': 'openidm-admin',
            //         'X-OpenIDM-Password': 'openidm-admin',
            //         'Content-Type': 'application/json'
            //     },
            //     data: wfdata
            // };
            // console.log(wfdata);
            //
            // axios(config)
            //     .then((response) => {
            //         if (response.data.failedPolicyRequirements.length > 0 && response.data.failedPolicyRequirements[0].policyRequirements.length > 0) {
            //         // came back WITH a *validation* error
            //             var errCode = response.data.failedPolicyRequirements[0].policyRequirements[0].policyRequirement,
            //                 errStringify = JSON.stringify(errCode),
            //                 subStr = errStringify.substring(1, errStringify.length - 1),
            //                 myStr = 'common.policyValidationMessages.' + subStr;
            //
            //             console.log(this.$t(myStr));
            //             this.validProperties[property] = this.$t(myStr);
            //         } else {
            //             // came back withOUT a *validation* error
            //             this.validProperties[property] = '';
            //         }
            //         console.log(JSON.stringify(response.data));
            //
            //         console.log(JSON.stringify(this.validProperties));
            //     })
            //     .catch(function (error) {
            //         console.log(error);
            //     });
            // console.log('This is after the api call is made');
        },

        save () {
            this.processTask = '';
            var loggedInUser, formUser, wfdata, i, adminCnt = 0, item, loginServiceInstance, basicUser;
            // loginServiceInstance = this.getRequestService({
            // headers: {
            //    'X-OpenIDM-NoSession': false,
            //    'X-OpenIDM-Password': this.encodeRFC5987IfNecessary(this.password),
            //    'X-OpenIDM-Username': this.encodeRFC5987IfNecessary(this.username)
            // }
            // });
            // loginServiceInstance.get('managed/user')
            // var loggedInUser, formUser, axios, config; // wfdata, config;
            if (this.userDetails.userName !== undefined) {
                // let saveData = { '_queryId': 'filtered-query&startTime' };
                loginServiceInstance = this.getRequestService({
                    headers: {
                        'X-OpenIDM-NoSession': true,
                        'Content-Type': 'application/json',
                        // 'Authorization': 'Basic b3BlbmlkbS1hZG1pbjptclBsMXh0bG4wMDE='
                        'Authorization': 'Basic ' + this.$t('pages.app.DEV_AUTH_TOKEN')
                    }
                });
                // loginServiceInstance.get('workflow/processinstance?_queryId=filtered-query&startTime')
                //     .then((worflowResults) => {
                //         var wfresult = worflowResults.data['result'];
                //         for (i = 0; i < wfresult.length; i++) {
                //             item = wfresult[i];
                //             console.log('ITEM: ' + item);
                //             if (item.processDefinitionId.includes(this.defName)) {
                //                 this.wfexists = true;
                //                 this.popupState = this.$t('pages.orgadmin.fail');
                //             }
                //         }
                //         if (!wfexists) {
                // let saveData = { '_queryFilter': 'userName+eq+"' + this.saveDetails.userName + '"' };
                loginServiceInstance.get('managed/user?_queryFilter=userName+eq+"' + this.saveDetails.userName + '"')
                    .then((formUserResponse) => {
                        var result = formUserResponse.data['result'];
                        if (result[0] !== undefined) {
                            basicUser = result[0];
                            formUser = result[0].organization;
                            loginServiceInstance.get('managed/user/' + this.user['userId'])
                                .then((loggedInUserResponse) => {
                                    var result = loggedInUserResponse.data;
                                    loggedInUser = result.organization;
                                    if (formUser === loggedInUser) {
                                        this.orgAdminMatch = true;
                                        loginServiceInstance.get('managed/user?_queryId=query-all')
                                            .then((queryAll) => {
                                                result = queryAll.data['result'];
                                                for (i = 0; i < result.length; i++) {
                                                    item = result[i];
                                                    if (item.isOrganizationAdmin) {
                                                        adminCnt++;
                                                    }
                                                }

                                                if (this.removeAdmin === undefined || this.removeAdmin === null || this.removeAdmin === '') {
                                                    this.removeAdmin = false;
                                                }
                                                let executeCall = false;
                                                if (this.removeAdmin && adminCnt > 1) {
                                                    executeCall = true;
                                                } else if (!this.removeAdmin) {
                                                    executeCall = true;
                                                }
                                                console.log('Remove admin: ' + this.removeAdmin + ' ExecuteCall: ' + executeCall + ' Admin count:' + adminCnt);
                                                if (executeCall) {
                                                    this.workflowService = this.getRequestService();
                                                    wfdata = JSON.stringify({
                                                        '_key': this.defName,
                                                        'userName': `${this.saveDetails.userName}`,
                                                        'description': `${this.saveDetails.description}`,
                                                        'userId': `${basicUser._id}`
                                                    });

                                                    this.workflowService.post('/workflow/processinstance/?_action=create', wfdata)
                                                        .then((response) => {
                                                            // console.log('Response: ' + response);
                                                            wfdata = JSON.stringify([{
                                                                'operation': 'replace',
                                                                'field': '/promotionDescription',
                                                                'value': `${this.saveDetails.description}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotingAdmin',
                                                                'value': `${this.user['userName']}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotingAdminRemove',
                                                                'value': `${this.removeAdmin}`
                                                            },
                                                            {
                                                                'operation': 'replace',
                                                                'field': '/promotionInProgress',
                                                                'value': 'true'
                                                            }
                                                            ]);
                                                            loginServiceInstance.patch('managed/user/' + basicUser['_id'], wfdata).then((updatedUserResponse) => {
                                                            }).catch((error) => {
                                                                error = undefined;
                                                                // console.log(error);
                                                                this.popupState = this.$t('pages.orgadmin.fail');
                                                            });
                                                            // if (this.removeAdmin) {
                                                            //     wfdata = JSON.stringify({
                                                            //         '_queryFilter': '/userName+eq+"' + this.user['userId'] + '"'
                                                            //     });
                                                            //     loginServiceInstance.patch('managed/user/' + basicUser['_id'], wfdata).then((removed) => {
                                                            //         if (removed.result.size() === 1) {
                                                            //             wfdata = JSON.stringify({
                                                            //                 'operation': 'replace',
                                                            //                 'field': 'isOrganizationAdmin',
                                                            //                 'value': 'false'
                                                            //             });
                                                            //             loginServiceInstance.patch('managed/user/' + removed.result[0]._id, wfdata).then((removed) => {
                                                            //
                                                            //             }).catch((error) => {
                                                            //                 console.log('Error: ' + error);
                                                            //                 this.popupState = this.$t('pages.orgadmin.fail');
                                                            //             });
                                                            //         }
                                                            //     }).catch((error) => {
                                                            //         console.log('Error: ' + error);
                                                            //         this.popupState = this.$t('pages.orgadmin.fail');
                                                            //     });
                                                            // }
                                                        })
                                                        .catch((error) => {
                                                            error = undefined;
                                                            // console.log(error);
                                                            this.popupState = this.$t('pages.orgadmin.fail');
                                                        });
                                                } else {
                                                    this.processTask = this.$t('pages.notFound.orgAdminZero');
                                                }
                                            })
                                            .catch(function (error) {
                                                error = undefined;
                                                // console.log(error);
                                            });
                                        this.$refs.successModal.show();
                                    } else {
                                        this.processTask = this.$t('pages.notFound.orgAdminDontMatch');
                                    }
                                })
                                .catch(function (error) {
                                    error = undefined;
                                    // console.log(error);
                                    this.popupState = this.$t('pages.orgadmin.fail');
                                });
                        } else {
                            this.popupState = this.$t('pages.orgadmin.fail');
                            this.$refs.successModal.show();
                        }
                    })
                    .catch(function (error) {
                        error = undefined;
                        // console.log(error);
                    });
                // console.log('This is after the api call is made');
                //     }
                // });
            }
        },

        successRequest () {
            this.$refs.successModal.hide();
            this.$router.push({
                name: 'Dashboard'
            });
        },

        isValid () {
            /* istanbul ignore next */
            return this.$validator.validateAll();
        },

        invokeWorkflow (payload, config) {
            this.makeUpdateRequest('selfservice/user', payload, config);
        },
        makeUpdateRequest (endpoint, payload, config = {}) {
            /* istanbul ignore next */
            let successMsg = config.successMsg || this.$t('common.user.profile.updateSuccess'),
                userId = this.$root.userStore.state.userId,
                selfServiceInstance = this.getRequestService({
                    headers: config.headers
                });

            /* istanbul ignore next */
            selfServiceInstance.patch(`${endpoint}/${userId}`, payload).then((response) => {
                this.$root.userStore.setProfileAction(response.data);
                this.displayNotification('success', successMsg);

                if (config.onSuccess) {
                    config.onSuccess();
                }
            })
                .catch((error) => {
                    /* istanbul ignore next */
                    let errorMsg = config.errorMsg || error.response.data.message;
                    this.displayNotification('error', errorMsg);

                    if (config.onError) {
                        config.onError(error);
                    }
                });
        }
    }
};
</script>

<style scoped lang="scss">
.ssrv-form-button {
    background-color: #0054AD;
}
.safeLabel {
    float: left;
}
</style>
